angular.module('impactx.lot').controller('LotBuyerDetailCtrl', LotBuyerDetailCtrl);
LotBuyerDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    'ToolbarService'
];

function LotBuyerDetailCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, ToolbarService) {
    var ctrl = this;

    dataGen.getData($scope, {id: $routeParams.id, lotId: $routeParams.lotId}, "/lot/buyerviewdetail").then(function () {
        defineButtons();
    });

    this.saveLotBuyer = function () {
        var dataObj = {
            lotBuyer: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/lot/buyersave").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    this.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/lot/buyerdelete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.saveLotBuyer,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return !$scope.data.readOnly && !$scope.data.mainPartReadOnly && $scope.data.id > 0;
    }
}